import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index.js";
import views from "@/views/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    redirect: { name: "Clients" },
    component: views.Dashboard,

    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/newuser/",
    name: "New User",
    component: views.NewUser,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login/",
    name: "Login",
    meta: { layout: "no-header" },
    component: views.Login,
  },
  {
    path: "/clients/",
    name: "Clients",
    component: views.Clients,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Client",
    path: "/clients/:clientId/",
    component: views.Client,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/projects/",
    name: "Projects",
    component: views.Projects,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Project",
    path: "/clients/:clientId/project/:projectId",
    component: views.Project,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/packages/",
    name: "Packages",
    component: views.Packages,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Package",
    path: "/packages/:packageId",
    component: views.Package,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters["login/isLoggedIn"]) {
      next();
      return;
    }
    next("/login/");
  } else {
    next();
  }
});

export default router;
